import { type PropsWithChildren, type JSX } from 'react';
import { useViewport } from '../../../hooks/useViewport';

type Props = {
  smallViewport?: boolean;
  mediumViewport?: boolean;
  largeViewport?: boolean;
};

/**
 * Component that renders its children only if the viewport matches the specified conditions.
 * It ONLY takes into account the size of the viewport, not the device type.
 */

export function VisibleOnly({
  children,
  smallViewport = false,
  mediumViewport = false,
  largeViewport = false,
}: PropsWithChildren<Props>): JSX.Element | null {
  const { isSmallViewport, isMediumViewport, isLargeViewport } = useViewport();

  const matches =
    (smallViewport && isSmallViewport) ||
    (mediumViewport && isMediumViewport) ||
    (largeViewport && isLargeViewport);

  return matches ? <>{children}</> : null;
}
